type ContactConstantsProps = {
  header: string;
  companyName: string;
  streetAddress: string;
  cityStateZip: string;
  phoneNumber: string;
  emailAddress: string;
};

export const CONTACT_CONSTANTS: ContactConstantsProps = {
  header: "Contact Us",
  companyName: "Tovani Hart",
  streetAddress: "609 A Columbia Street SW",
  cityStateZip: "Olympia, WA 98501",
  phoneNumber: "(360) 339-8274",
  emailAddress: "info@tovanihart.com",
};

export default CONTACT_CONSTANTS;
